<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent:0px;">Following her family split, Valerie McKee decided to pursue a dream of volunteering in a third world country. Once she took retirement from her prestigious job in a renowned public Cambridge school, she gained a place with Voluntary Services Overseas as a teaching advisor in northern Ethiopia.</p><br/>
<p style="text-indent:0px;">This candid autobiography records the highs and the many lows of that extraordinary year, during which, she aimed not just to survive but to be an effective volunteer.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?7079b110